import ViewFilter, {
    SortOrder,
} from "@/domain/entities/customViews/ViewFilter";
import { useToast } from "@/hooks/utils/useToast";
import { viewFilterToDomainMapper } from "@/mappers/customView/viewFilterMapper";
import { useCustomViews } from "@cs_teamwaydev/mailvista-sdk_react";
import { useTranslation } from "react-i18next";

const useGenerateViewFilters = () => {
    const customViews = useCustomViews();
    const { toast } = useToast();
    const { t } = useTranslation();

    const generateViewFilters = async (
        userPrompt: string,
    ): Promise<ViewFilter> => {
        try {
            const result = await customViews.generateViewFilter(userPrompt);

            return viewFilterToDomainMapper(result);
        } catch (error) {
            console.error(error);
            toast({
                title: t("errors.customViews.generateViewFilters"),
                description: t("errors.global.description"),
                variant: "error",
            });

            return new ViewFilter({
                keywords: [],
                startDate: undefined,
                endDate: undefined,
                identifiedSendersEmails: [],
                identifiedRecipientsEmails: [],
                sortOrder: SortOrder.DESC,
            });
        }
    };

    return generateViewFilters;
};

export default useGenerateViewFilters;
